import gql from 'graphql-tag';

const GET_INVITATIONS = gql`
  query GetInvitations($filter: InvitationFilterInput) {
    getInvitations(filter: $filter) {
      invitations {
        id
        email
        workspaceId
        customerId
        token
        status
      }
    }
  }
`;

export default {
  GET_INVITATIONS,
};
